import { rule } from '../../domain/badge-composition-rule.js';

/**
 * @param {BadgeComposition} composition
 * @returns {BadgeCompositionRule[]}
 */
export const footerRules = composition => {
  const { variantIs, planIsAtLeast } = composition.checkers;

  return [
    rule('footer')
      .when(variantIs('footer'))
      .set(() => ({
        constraints: {
          alwaysMaximized: true,
        },
        container: {
          type: 'round-rectangle-concealed-top-left',
        },
        parts: {
          contents: {
            present: true,
          },
          aubySeal: {
            offsetType: 'md',
            offsetBottom: false,
          },
          headerText: {
            type: 'full',
            center: false,
          },
          carousel: {
            location: 'contents',
            size: 'md',
          },
          dateBanner: {
            size: 'md',
          },
          button: {
            size: 'md',
          },
          accordion: {
            size: 'sm',
          }
        },
      })),

    rule('footer/start+')
      .when(variantIs('footer').and(planIsAtLeast('start')))
      .set(() => ({
        parts: {
          accordion: {
            show: true,
          }
        }
      }))
  ];
};
